export default __webpack_public_path__ + "noRecordsFound.075d155ce34051fec329cad797210a10.svg";